/*
 * What this session is allowed to do, as the server said at sign-in.
 *
 *   'active'         a full plan
 *   'trial'          a free trial that is still running
 *   'trial_expired'  a free trial that ran out — the app shows the plans only
 *
 * This is for the interface only: which buttons to show, which banner, where
 * to send someone. The server enforces every one of these limits on its own
 * (noTrial.js, requireActivePlan.js), so a button that slipped through would
 * still be refused.
 */

function ss(key) {
  try { return sessionStorage.getItem(key) || '' } catch (err) { return '' }
}

export function accessState() {
  return ss('AccessState') || 'active'
}

export function isTrial() {
  const state = accessState()
  return state === 'trial' || state === 'trial_expired'
}

export function isTrialExpired() {
  return accessState() === 'trial_expired'
}

/* Milliseconds left in a running trial, or 0. */
export function trialMsLeft() {
  const raw = ss('TrialEndsAt')
  if (!raw) return 0
  const left = new Date(raw).getTime() - Date.now()
  return Number.isFinite(left) && left > 0 ? left : 0
}

/* "23h 14m", "42m", "under a minute" */
export function formatLeft(ms) {
  const mins = Math.floor(ms / 60000)
  if (mins < 1) return 'under a minute'
  const h = Math.floor(mins / 60)
  const m = mins % 60
  return h > 0 ? h + 'h ' + m + 'm' : m + 'm'
}

/* Pages an expired trial may still open. Everything else redirects to plans. */
export const EXPIRED_TRIAL_PAGES = ['plans', 'profile']
